import { Divider } from '@/components/base/divider'
import { NavLink } from '@/components/layout/navlink'
import { Outlet } from 'react-router'

export const Layout = () => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-8 items-center">
          <NavLink to="/documents">Documents</NavLink>
        </div>
        <Divider />
        <Outlet />
      </div>
    </>
  )
}
